// internal imports
import { useAppContext } from "../../layout/layout";
import { Image } from "./logo.component.styles";

const Logo = () => {
  const { isDarkTheme } = useAppContext();
  return (
    <Image
      src={`/assets/logo/${
        isDarkTheme ? "custome-logo-light.svg" : "custome-logo-dark.svg"
      }`}
      alt="logo"
    />
  );
};
export default Logo;
